import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveCoverImage,
  updateCoverImage,
  deleteCoverImage
} from "./carecellCoverImage.js";

import {
  saveCoverImageSuccess,
  saveCoverImageFailure,
  updateCoverImageSuccess,
  updateCoverImageFailure,
  deleteCoverImageSuccess,
  deleteCoverImageFailure,
} from "./carecellCoverImageActions.js";

// ✅ SAVE Saga
function* saveCoverImageSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveCoverImage, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(saveCoverImageSuccess(data.data || apiPayloadRequest));
      if (action.callback) action.callback({ type: 1, data: data.data });
    } else {
      yield put(saveCoverImageFailure(data.error || "Save failed"));
      if (action.callback) action.callback({ type: 0, error: data.error });
    }
  } catch (error) {
    yield put(saveCoverImageFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ UPDATE Saga (with fallback to SAVE if record not found)
function* updateCoverImageSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateCoverImage, apiPayloadRequest);


    if (data?.type === 1) {
      yield put(updateCoverImageSuccess(data.data || apiPayloadRequest));
      if (action.callback) action.callback({ type: 1, data: data.data });
    } else {
      // fallback: if "unable to find data" -> save
      const errMsg =
        data?.error || data?.message || data?.data || "Update failed";

      if (typeof errMsg === "string" && errMsg.toLowerCase().includes("unable to find data")) {
                const fallback = yield call(saveCoverImage, apiPayloadRequest);

        if (fallback?.type === 1) {
          yield put(saveCoverImageSuccess(fallback.data));
          if (action.callback) action.callback({ type: 1, data: fallback.data });
        } else {
          yield put(updateCoverImageFailure(fallback.error || "Fallback save failed"));
          if (action.callback) action.callback({ type: 0, error: fallback.error });
        }
      } else {
        yield put(updateCoverImageFailure(errMsg));
        if (action.callback) action.callback({ type: 0, error: errMsg });
      }
    }
  } catch (error) {
    yield put(updateCoverImageFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}
// Saga
function* deleteCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};
     // Should log {_id, carecellObjId, carecellCoverImageObjId}
    const data = yield call(deleteCoverImage, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(deleteCoverImageSuccess(apiPayloadRequest));
      if (callback) callback({ type: 1, data });
    } else {
      yield put(deleteCoverImageFailure(data?.error || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
        yield put(deleteCoverImageFailure(error.message));
    if (action.payload?.callback) action.payload.callback({ type: 0, error: error.message });
  }
}



// ✅ WATCHER
export default function* coverImageWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CARECELL_COVERIMAGE_REQUEST, saveCoverImageSaga);
  yield takeLatest(actionTypes.UPDATE_CARECELL_COVERIMAGE_REQUEST, updateCoverImageSaga);
  yield takeLatest(actionTypes.DELETE_CARECELL_COVERIMAGE_REQUEST, deleteCoverImageSaga);

}
